/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Meta/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Meta({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Content/Profile/ProfileData/Tag/Payer/Relationships/Content/Relationship/Meta"
  
}) {
let dependentPersonToPersonRecordBirthDateValueData = fromData.useDataFormat({ viewPath,
context: 'dependentPerson',
path: 'to_person_record.birth_date',
format: fromFormat.age,
})
let constantData = ', '
let dependentPersonToPersonRecordGenderValueData = fromData.useDataValue({ viewPath,
context: 'dependentPerson',
path: 'to_person_record.gender',
})
let aggregateData = fromAggregate.join(dependentPersonToPersonRecordBirthDateValueData, constantData, dependentPersonToPersonRecordGenderValueData)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="dependentPerson.to_person_record.birth_date"
 format="/Data/format.js age"
 data="', '"
 data="dependentPerson.to_person_record.gender"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
 letterSpacing={0.1}
 color={dtColorsNeutral500}
 size="small"
/>
{children}
</React.Fragment>)
}